import api from '@/api'
import { downloadCsv } from '@/transformer/file'

const getDefaultState = () => {
  return {
    validations: {},
    list: [],
    total: 0,
    ctx: {},
    editData: {},
    pfIcoDataURL: null,
    pfBgDataURL: null
  }
}

export default {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    validations(state) {
      return state.validations
    },
    list(state) {
      return state.list
    },
    total(state) {
      return state.total
    },
    ctx(state) {
      return state.ctx
    },
    editData(state) {
      return state.editData
    },
    pfIcoDataURL(state) {
      return state.pfIcoDataURL
    },
    pfBgDataURL(state) {
      return state.pfBgDataURL
    }
  },
  mutations: {
    setValidations(state, validations) {
      state.validations = validations
    },
    setList(state, list) {
      state.list = list
    },
    setTotal(state, total) {
      state.total = total
    },
    setCtx(state, ctx) {
      state.ctx = ctx
    },
    setEditData(state, editData) {
      state.editData = editData
    },
    setPfIcoDataURL(state, pfIcoDataURL) {
      state.pfIcoDataURL = pfIcoDataURL
    },
    setPfBgDataURL(state, pfBgDataURL) {
      state.pfBgDataURL = pfBgDataURL
    },
    resetState(state) {
      state = Object.assign(state, getDefaultState())
    }
  },
  actions: {
    async getUsers({ commit }, { adminStatus, ctx }) {
      this.commit('user/setCtx', ctx)

      try {
        const data = await api.user.list({
          currentPage: ctx.currentPage,
          perPage: ctx.perPage,
          sortBy: ctx.sortBy,
          sortDesc: ctx.sortDesc,
          filter: ctx.filter,
          admin_status: adminStatus
        })
        this.commit('user/setList', data.list)
        this.commit('user/setTotal', data.total)
      } catch (error) {
        // eslint-disable-next-line no-unused-vars
        const { data } = error.response
      }
    },
    async createUser({ commit, getters }) {
      const editData = getters.editData

      try {
        // eslint-disable-next-line no-unused-vars
        const data = await api.user.create({
          tags: JSON.stringify(editData.tags),
          last_name: editData.last_name,
          first_name: editData.first_name,
          email: editData.email,
          password: editData.password,
          password_confirm: editData.password_confirm,
          admin_status: editData.admin_status
        })
        this.commit('user/setValidations', {})
        return Promise.resolve(data)
      } catch (error) {
        // eslint-disable-next-line no-unused-vars
        const { data } = error.response
        this.commit('user/setValidations', data.validations)
      }
    },
    async updateUser({ commit, getters }) {
      const editData = getters.editData

      try {
        // eslint-disable-next-line no-unused-vars
        const data = await api.user.update({
          id: editData.id,
          tags: JSON.stringify(editData.tags),
          last_name: editData.last_name,
          first_name: editData.first_name,
          email: editData.email,
          password: editData.password,
          password_confirm: editData.password_confirm,
          admin_status: editData.admin_status
        })
        this.commit('user/setValidations', {})
        return Promise.resolve(data)
      } catch (error) {
        // eslint-disable-next-line no-unused-vars
        const { data } = error.response
        this.commit('user/setValidations', data.validations)
        return Promise.reject(data)
      }
    },
    async deleteUser({ commit }, { id }) {
      try {
        // eslint-disable-next-line no-unused-vars
        const data = await api.user._delete({
          id: id
        })
        return Promise.resolve(data)
      } catch (error) {
        // eslint-disable-next-line no-unused-vars
        const { data } = error.response
        return Promise.reject(data)
      }
    },
    async downloadCSV({ commit }, { adminStatus }) {
      try {
        // eslint-disable-next-line no-unused-vars
        const data = await api.user.downloadCSV({
          admin_status: adminStatus
        })
        downloadCsv(data.list, data.filename)
      } catch (error) {
        // eslint-disable-next-line no-unused-vars
        const { data } = error.response
      }
    },
    async getPfDataURL({ commit }) {
      try {
        // eslint-disable-next-line no-unused-vars
        const data = await api.profile.getPfDataURL()
        if (data.pfIcoDataURL || data.pfIcoDataURL === '') this.commit('user/setPfIcoDataURL', data.pfIcoDataURL)
        if (data.pfBgDataURL || data.pfBgDataURL === '') this.commit('user/setPfBgDataURL', data.pfBgDataURL)
      } catch (error) {
        // eslint-disable-next-line no-unused-vars
        const { data } = error.response
      }
    }
  }
}
